import CustomStore from "devextreme/data/custom_store";
import { apiConfiguration } from "../apiConfig";
import { AssistitiApi } from "../data/apis";
import { useContext, useMemo } from "react";
import TenantContext from "../contexts/tenantContext";

export function useAssistitiDataSource() {
    const api = new AssistitiApi(apiConfiguration);
    const { currentTenant } = useContext(TenantContext);

    const dataSource = useMemo(() => {   
        return new CustomStore({
          key: "id",
          loadMode: 'raw',
          load: (loadOptions) => {
            return api.getAssistiti({ tenantId: currentTenant.Id });
          },
    
          byKey: (key) => {
            return api.getAssistitoById({
                tenantId: currentTenant.Id,
                assistitoId: key
            });
          },
    
          insert: (values) => {
            return api.insertAssistito({
                tenantId: currentTenant.Id,
                assistitoCreateDTO: values
            });
          },
    
          update: (key, values) => {
            return api.updateAssistito({
                tenantId: currentTenant.Id,
                assistitoId: key,
                assistitoUpdateDTO: values  
            });
          },
    
          remove: (key) => {
            return api.deleteAssistito({
                tenantId: currentTenant.Id,
                assistitoId: key    
            });
          }
        });
      }, [currentTenant]);
    
      return dataSource;
}


